module.exports = __webpack_public_path__ + "img/set-icon.d8157052.png";